import { Slide } from '@/components/core/Slide';
import videoFile from './15-bubbles.webm';
import audioFile from './16-eva-reflection.mp3';

const autoNextDuration = 13500;
const transcript = `
  Jonathan... kunnen we het thuis hebben over hoe ik meer als Marte word? 
  Als ik haar zie, vind ik mijn eigen representatie erg beperkt. 
  Geen armen, geen benen…
`;

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      audio={audioFile}
      visualizer="full"
      autoNext={autoNextDuration}
      transition="fade"
      background={{
        video: videoFile,
      }}
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
